const STORAGE_KEY = "pendingIotConnections";

interface PendingIotConnection {
    assetId: string;
    timestamp: number;
}

function getAll(): PendingIotConnection[] {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch {
        return [];
    }
}

export function setPendingIotConnection(assetId: string): void {
    const entries = getAll().filter(p => p.assetId !== assetId);
    entries.push({ assetId, timestamp: Date.now() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

export function getPendingIotConnection(assetId: string): PendingIotConnection | null {
    return getAll().find(p => p.assetId === assetId) || null;
}

export function removePendingIotConnection(assetId: string): void {
    const remaining = getAll().filter(p => p.assetId !== assetId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(remaining));
}
